import RouteNameEnum from '@/router/RouteNameEnum';
import { FunnelStep } from '../FunnelStep';
import getQueryParams from '@/utils/getQueryParams';
import store from '@/store/BookingStore';
import { createRequestData } from '@/logic/createRequestParams';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { hanldeSecureless } from '../middleware/hanldeSecureless';
import { StatusV2 } from '../../../../../requests-module/src';
import checkIsPackageFlight from '@/logic/options/checkIsPackageFlight';
import { startGlobalPollingFlight } from '@/composables/pollingFlightController';

export const transferStep = new FunnelStep({
    name: RouteNameEnum.Transfer,
    dependencies: [],
    init: async () => {
        console.log('init(): Initializing Transfer Page - refresh call');
        if (!store.getters.getToken) {
            console.log('init(): Initializing Transfer Page - make an init call to get BO with defaults');
            // no bo - create one from url 
            const queryParams = getQueryParams();
            const requestData = createRequestData(queryParams);

            // await BookingFunnelService.initBookingTransfer(requestData)
        } else {
            console.log('init(): Initializing Transfer Page - if bo exist, just make a refresh call');

            // has bo, make a refresh call with alt Transfer
            const response = await BookingFunnelService.refreshBookingTransfer() // ()

            if ('error' in response) {
                throw new Error('Error with api')
            }
            // if (checkIsPackageFlight(store.getters.getBooking)) {
            //     startGlobalPollingFlight(store.getters.getBooking.boReference);
            // }
            if (response.status == StatusV2.PROCESSING) {
                // proccesing payment go to /payment page
                return '/payment'
            }
            if (response.status == StatusV2.SUCCESS) {
                return '/paid'
            }
        }

        return false
    },
    hasToBeLoggedIn: false

});